import ClienteleOption from './ClienteleOption.vue';
import HumanResourcesOption from './HumanResourcesOption.vue';
import LikertOption from './LikertOption.vue';
import LongTextOption from './LongTextOption.vue';
import MultipleChoiceOption from './MultipleChoiceOption.vue';
import MultipleChoiceDataSetOption from './MultipleChoiceDataSetOption.vue';
import PointsOfServiceOption from './PointsOfServiceOption.vue';
import ShortTextOption from './ShortTextOption.vue';
import SubOrgOption from './SubOrgOption.vue';
import TableFormatOption from './TableFormatOption.vue';
import TextBlockOption from './TextBlockOption.vue';
import { LanguageObject } from '@/i18n';
import { Question } from '@/utils/SurveyUtils';
import { DataSet } from '@/utils/DataSetUtils';

// TODO: there has to be a better place to put this, but vue files complain if they export interfaces
interface ClienteleOptions {
  percentage: LanguageObject;
  period: LanguageObject;
  totalvisit: LanguageObject;
  francophonevisit: LanguageObject;
  totalclients: LanguageObject;
  francophoneclients: LanguageObject;
}

interface HumanResourcesOptions {
  source: 'sub_organization' | 'points_of_service';
  positioncounttype: 'Manitoba_v1' | 'Simple_v1';
  department: {
    active: boolean;
    label?: LanguageObject;
  };
  position: {
    active: boolean;
    label?: LanguageObject;
  };
  language?: {
    [key: string]: LanguageObject;
  };
}

interface LikertOptions {
  showUnknown: boolean;
  showNotes: boolean;
  showPrimary: boolean;
  noterows: number;
  language: {
    primary: {
      true: LanguageObject;
      false: LanguageObject;
      unknown?: LanguageObject;
    };
    secondary: {
      question: LanguageObject;
    };
    notes: LanguageObject;
  };
  secondary: {
    options: {
      text: LanguageObject;
      acronym: LanguageObject;
      key: string;
      score?: number;
    }[];
  };
}

interface LongTextOptions {
  rows: number;
}

interface MultipleChoiceOptions {
  choices: {
    shorttext: LanguageObject;
    longtext?: LanguageObject;
    key: string;
  }[];
  type: 'dropdown' | 'checkbox';
  multiple: boolean;
  sort: 'manual' | 'alphabetical';
  other: boolean;
  otherlabel: LanguageObject;
  displayalloptions: boolean;
  notes: boolean;
  noteslabel: LanguageObject;
}

interface MultipleChoiceDataSetOptions {
  dataset: Partial<DataSet>;
  type: 'enforce' | 'guideline';
  multiple: boolean;
  label: LanguageObject;
}

interface PointsOfServiceOptions {
  address: boolean;
  singlelabel: LanguageObject;
  multilabel: LanguageObject;
}

interface ShortTextOptions {
  rule?: 'email' | 'url' | 'regex';
  regex?: string;
  errorMessage?: LanguageObject;
}

interface SubOrgOptions {
  singlelabel: LanguageObject;
  multilabel: LanguageObject;
}

interface TableFormatOptions {
  layout: {
    header: LanguageObject;
    question?: Partial<Question>;
  }[];
}

interface TextBlockOptions {
  text: LanguageObject;
}

export default {
  clientele: ClienteleOption,
  human_resources: HumanResourcesOption,
  likert: LikertOption,
  long_text: LongTextOption,
  multiple_choice: MultipleChoiceOption,
  multiple_choice_data_set: MultipleChoiceDataSetOption,
  points_of_service: PointsOfServiceOption,
  short_text: ShortTextOption,
  sub_organization: SubOrgOption,
  table_format: TableFormatOption,
  text_block: TextBlockOption,
};

export {
  ClienteleOptions,
  HumanResourcesOptions,
  LikertOptions,
  LongTextOptions,
  MultipleChoiceOptions,
  MultipleChoiceDataSetOptions,
  PointsOfServiceOptions,
  ShortTextOptions,
  SubOrgOptions,
  TableFormatOptions,
  TextBlockOptions,
};
